import {
  EditJackpotData,
  AddGameJackpotData,
  AddMegaJackpotData,
  AddBetshopJackpotData,
  GetJackpotsRequest,
  JackpotDetailRequest,
  JackpotDetailsResponse,
  JackpotsResponse,
  JackpotByIdResponse
} from "../../../models";
import { BaseApiService } from "../../base-api-service";
import { ApiVersions } from "../../../enums";
import { env } from "../../../environment";

class JackpotsController extends BaseApiService {

  public async getJackpots(params?: GetJackpotsRequest,): Promise<JackpotsResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/jackpot`;
    return await this.http.get(url, { params });
  }

  public async getJackpotById(id: number, type: number): Promise<Partial<JackpotByIdResponse>> {
    const url = `${this.url}/api/${ApiVersions.V1}/jackpot/${id}/${type}`;
    return await this.http.get(url);
  }

  public async addMegaJackpot(data: AddMegaJackpotData): Promise<void> {
    const url = `${this.url}/api/${ApiVersions.V1}/jackpot/mega`;
    return await this.http.post(url, data);
  }

  public async addBetshopJackpot(data: AddBetshopJackpotData): Promise<void> {
    const url = `${this.url}/api/${ApiVersions.V1}/jackpot/betshop`;
    return await this.http.post(url, data);
  }

  public async addGameJackpot(data: AddGameJackpotData): Promise<void> {
    const url = `${this.url}/api/${ApiVersions.V1}/jackpot/game`;
    return await this.http.post(url, data);
  }

  public async getJackpotDetails(params: JackpotDetailRequest): Promise<JackpotDetailsResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/ticket/jackpot-win`; // )
    return await this.http.get(url, { params });
  }

  public async editMegaJackpot(data: EditJackpotData): Promise<void> {
    const url = `${this.url}/api/${ApiVersions.V1}/jackpot/mega`;
    return await this.http.put(url, data);
  }

  public async editBetshopJackpot(data: EditJackpotData): Promise<void> {
    const url = `${this.url}/api/${ApiVersions.V1}/jackpot/betshop`;
    return await this.http.put(url, data);
  }

  public async editGameJackpot(data: EditJackpotData): Promise<void> {
    const url = `${this.url}/api/${ApiVersions.V1}/jackpot/game`;
    return await this.http.put(url, data);
  }

}

export const jackpotController = new JackpotsController({
  url: env.httpUrl,
});
